module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "home"
  }, [_c('div', {
    staticClass: "page-header",
    attrs: {
      "id": "home-page-header"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "flexbox"
  }, [_c('div', {
    staticClass: "homethumb"
  }, [_c('div', {
    staticClass: "thumb",
    style: ({
      'background-image': 'url(' + _vm.latestJson.thumbnail + ')'
    })
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "flexstart"
  }, [_c('div', {
    staticClass: "lvl-sorange font12 mr10"
  }, [_vm._v("レベル " + _vm._s(_vm.latestLevelNo) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "lvl-text mbold"
  }, [_vm._v("ユニット " + _vm._s(_vm.latestUnitNo) + " 「" + _vm._s(_vm.latestUnitTitle) + "」: レッスン " + _vm._s(_vm.latestLessonIndex + 1))])]), _vm._v(" "), _c('div', {
    staticClass: "flexstart mt10"
  }, [_c('div', {
    staticClass: "font35 mbold mr10"
  }, [_vm._v(_vm._s(_vm.latestPathTitle))]), (_vm.latestState.length != 0) ? _c('div', {
    staticClass: "lvl-status"
  }, [_vm._v(_vm._s(_vm.latestState))]) : _vm._e()])]), _vm._v(" "), _c('button', {
    staticClass: "btn-lblue font25",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.startLesson
    }
  }, [_vm._v(_vm._s(_vm.buttonText))])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "actvt-list"
  }, [_c('div', {
    staticClass: "actvt-inner"
  }, _vm._l((_vm.jsonData.levels), function(levelJson) {
    return _c('div', {
      staticClass: "actvt-button"
    }, [(levelJson.levelNo === _vm.currentLevelNo) ? _c('button', {
      staticClass: "active",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.clickLevel(levelJson.levelNo)
        }
      }
    }, [_vm._v("レベル" + _vm._s(levelJson.levelNo))]) : _c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.clickLevel(levelJson.levelNo)
        }
      }
    }, [_vm._v("レベル" + _vm._s(levelJson.levelNo))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "unit-content"
  }, [(_vm.isDocomo) ? _c('div', {
    staticClass: "wifi-message",
    attrs: {
      "id": "wifi-message"
    }
  }, [_c('p', {
    staticClass: "wifi-message"
  }, [_vm._v("各項目において初回ダウンロード時10～50MBダウンロードされます。※Wi-Fi推奨")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inner"
  }, [_c('div', [(_vm.backDisabled) ? _c('div', {
    staticClass: "slider-prev"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.backUnit
    }
  }, [_vm._v("back")])]) : _vm._e(), _vm._v(" "), (_vm.goDisabled) ? _c('div', {
    staticClass: "slider-next"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goUnit
    }
  }, [_vm._v("go")])]) : _vm._e()]), _vm._v(" "), (_vm.isMobile) ? _c('div', {
    staticClass: "slick-slider"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('HomeUnit', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUnit),
      expression: "showUnit"
    }],
    staticClass: "inner slick-item",
    attrs: {
      "currentLevelJson": _vm.currentLevelJson,
      "currentLevelNo": _vm.currentLevelNo,
      "currentUnitNo": _vm.currentUnitNo,
      "currentUnitJson": _vm.currentUnitJson,
      "index": 0,
      "isDocomo": _vm.isDocomo
    },
    on: {
      "clickLesson": _vm.clickLesson,
      "showLessonDetail": _vm.showLessonDetail,
      "startLessonForMobile": _vm.startLessonForMobile
    }
  })], 1)], 1) : _c('div', {
    staticClass: "slick-slider"
  }, _vm._l((_vm.unitCount), function(n, index) {
    return _c('div', [_c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [_c('HomeUnit', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showUnit),
        expression: "showUnit"
      }],
      staticClass: "inner slick-item",
      attrs: {
        "currentLevelJson": _vm.currentLevelJson,
        "currentLevelNo": _vm.currentLevelNo,
        "currentUnitNo": _vm.currentUnitNo,
        "currentUnitJson": _vm.currentUnitJson,
        "index": index
      },
      on: {
        "clickLesson": _vm.clickLesson,
        "showLessonDetail": _vm.showLessonDetail
      }
    })], 1)], 1)
  }), 0)])])])])]), _vm._v(" "), (_vm.showLessonDetailFlag) ? _c('LessonDetail', {
    attrs: {
      "levelNo": _vm.lessonDetailLevelNo,
      "unitNo": _vm.lessonDetailUnitNo,
      "unitTitle": _vm.lessonDetailUnitTitle,
      "lessonIndex": _vm.lessonDetailLessonIndex,
      "lessonJson": _vm.lessonDetailLessonJson
    },
    on: {
      "close": function($event) {
        _vm.showLessonDetailFlag = false
      },
      "clickLessonDetail": _vm.clickLesson,
      "startLessonForMobile": _vm.startLessonForMobile
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7932a772", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-7932a772","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 637
// module chunks = 1